import React from 'react';
import { useHasOverflow } from '../hooks/useHasOverflow';
import styles from './Collapsible.module.css';

/**
 * Show/hide and animate collapsible content
 * @param {React.ReactNode} props.children The content to displayu
 * @param {number} props.heightPadding Padding to add to the max-height if the content has some variable height while in use.
 * @param {boolean} props.collapsed Whether or not to display the content.
 * @returns {JSX.Element} The final component shown or hidden based on 'collapsed'
 */
export const Collapsible: React.FC<{
	children: React.ReactNode;
	heightPadding?: number;
	collapsed: boolean;
}> = ({ children, collapsed, heightPadding }) => {
	const [overflow, ref] = useHasOverflow();

	const maxHeight = !collapsed && overflow.height ? overflow.height : 0;

	return (
		<div
			ref={ref}
			style={{ maxHeight: maxHeight + ((!collapsed && heightPadding) || 0) }}
			className={styles.collapsible}
		>
			{children}
		</div>
	);
};
